import { IComponentOptions, IController } from "angular";
export class GhInputSearchCtrl implements IController {
  onSearch: ({ query: string }) => void;
  query: string;
  placeholder: string;

  search(query: string): void {
    this.onSearch({ query });
  }

  clearSearch(): void {
    this.query = "";
    this.search(this.query);
  }
}

export const GhInputSearchComponent: IComponentOptions = {
  templateUrl: require("../views/gh-input-search.jade"),
  controller: GhInputSearchCtrl,
  controllerAs: "$ctrl",
  bindings: {
    onSearch: "&",
    placeholder: "@",
  },
};
